module.exports = __webpack_public_path__ + "static/fx_3.b80bd4f2.jpg";